import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { isEmpty } from 'lodash';
import Page from 'Components/Page';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from '../../Components/CenteredSpinner';
import grey from '@material-ui/core/colors/grey';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import TokensNavbar from '../../Components/TokensNavbar';

const pageStyles = theme => ({
  pageWrapper: {
    paddingLeft: '3%',
    paddingRight: '3%',
    textAlign: 'center',
  },
  tokenImage: {
    width: '100%',
    margin: 'auto',
  },
  table: {
    fontWeight: '.5rem',
  },
  infoContainer: {
    backgroundColor: grey[100],
    borderRadius: '8px',
  },
  infoMain: {
    width: '100%',
  },
  tokenType: {
    color: grey[500],
  },
  extraInfo: {
    fontSize: '15px',
    wordBreak: 'break-word',
    '& span': {
      marginRight: '8px',
      color: grey[400],
    },
  },
  tokenCreator: {
    color: grey[500],
  },
  tokenOwner: {
    color: grey[500],
    marginTop: '24px',
  },
  description: {
    color: grey[700],
    marginTop: '24px',
  },
  imageHash: {
    color: grey[700],
    marginTop: '24px',
  },
  video: {
    maxWidth: '100%',
    maxHeight: '500px',
    outline: 'none',
  },
  extraInfoContainer: {
    '@media (max-width: 720px)': {
      flexDirection: 'column',
    },
  },
  tokenId: {
    '@media (max-width: 720px)': {
      marginTop: '16px',
    },
  },
  ownersArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  ownerGrid: {
    marginTop: '24px',
    border: '1px solid #999',
    display: 'grid',
    gridTemplateColumns: '100px auto',
  },
  firstOwnerGrid: {
    marginTop: 0,
  },
  ownerInfo: {
    fontSize: '14px',
    borderBottom: '1px solid #999',
  },
  ownerInfoHeader: {
    borderRight: '1px solid #999',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ownerInfoData: {
    padding: '8px',
    wordBreak: 'break-all',
    textAlign: 'left',
  },
  ownerInfoLast: {
    borderBottom: 'none',
  },
});

function Info({ classes, tokenId, contractAddress }) {
  const [tokenInfo, setTokenInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!tokenInfo) {
      const getTokenInformation = async () => {
        const ownerfyResponse = await axios.get(
          `https://us-central1-receiptcoin-receiptchain-de560.cloudfunctions.net/app/api/items/${tokenId}`,
        );
        const OpenseaResponse = await axios.get(`https://api.opensea.io/api/v1/asset/${contractAddress}/${tokenId}/`);
        // console.log(`getOwnerfyTokenInformation response`, ownerfyResponse);
        console.log(`owners response`, OpenseaResponse.data.top_ownerships);

        setTokenInfo({
          ...tokenInfo,
          ...ownerfyResponse.data,
          owners: OpenseaResponse.data.top_ownerships,
        });

        setTimeout(function () {
          const videoPlayer = document.getElementById('token-video');
          if (videoPlayer) {
            videoPlayer.play();
          }
        }, 1000);
      };

      getTokenInformation();
    }
  }, [contractAddress, tokenId, tokenInfo]);

  console.log(`tokenInfo`, tokenInfo);

  return (
    <Page wrapperStyles={classes.pageWrapper} NavBarComponent={TokensNavbar}>
      <Typography variant="h1">Token Information</Typography>
      {tokenInfo ? (
        <Box maxWidth="900px" margin="auto">
          {tokenInfo.animation_url ? (
            <video id="token-video" controls className={classes.video} autoplay loop muted>
              <source src={tokenInfo.animation_url} type="video/mp4" />
              Your browser does not support playing videos.
            </video>
          ) : (
            <img src={tokenInfo.image} alt="Token" className={classes.tokenImage} />
          )}
          <Box display="flex" justifyContent="space-between" mt={5} className={classes.extraInfoContainer}>
            <Typography variant="body1" className={classes.extraInfo}>
              <span>Contract Address:</span> {contractAddress}
            </Typography>
            <Typography variant="body1" className={clsx(classes.extraInfo, classes.tokenId)}>
              <span>Token ID:</span> {tokenId}
            </Typography>
          </Box>
          <Box p={4} mt={1} display="flex" className={classes.infoContainer}>
            <Box flex={1} className={classes.infoMain}>
              <Typography variant="h2">{tokenInfo.name}</Typography>
              <Typography variant="body1" className={classes.tokenCreator}>
                Created by {tokenInfo.creator}
              </Typography>
              <Typography variant="body1" className={classes.tokenOwner}>
                Owned by
              </Typography>
              <div className={classes.ownersArea}>
                {tokenInfo.owners.map((ownerInfo, index) => (
                  <div className={clsx(classes.ownerGrid, index === 0 && classes.firstOwnerGrid)}>
                    <Typography variant="body1" className={clsx(classes.ownerInfo, classes.ownerInfoHeader)}>
                      <strong>Address</strong>
                    </Typography>
                    <Typography variant="body1" className={clsx(classes.ownerInfo, classes.ownerInfoData)}>
                      {ownerInfo.owner.address}
                    </Typography>

                    <Typography
                      variant="body1"
                      className={clsx(
                        classes.ownerInfo,
                        classes.ownerInfoHeader,
                        index + 1 === tokenInfo.owners.length && classes.ownerInfoLast,
                      )}
                    >
                      <strong>Quantity</strong>
                    </Typography>
                    <Typography
                      variant="body1"
                      className={clsx(
                        classes.ownerInfo,
                        classes.ownerInfoData,
                        index + 1 === tokenInfo.owners.length && classes.ownerInfoLast,
                      )}
                    >
                      {ownerInfo.quantity}
                    </Typography>
                  </div>
                ))}
              </div>
              <Typography variant="body1" className={classes.description}>
                {tokenInfo.description}
              </Typography>
              {/* <Typography variant="body1" className={classes.imageHash}>
                <strong>Image Hash:</strong> ABCABC
              </Typography> */}
            </Box>
            <div className={classes.infoExtra}>
              {/* <Typography variant="body1" className={classes.tokenType}>
                {tokenInfo.type === 'fungibleDigitalAsset' ? 'Fungible NFT' : 'NFT'}
              </Typography> */}
            </div>
          </Box>
        </Box>
      ) : (
        <CenteredSpinner />
      )}
    </Page>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    tokenId: ownProps.match.params.tokenId,
    contractAddress: ownProps.match.params.contractAddress,
  };
}

export default withRouter(connect(mapStateToProps, null)(withStyles(pageStyles)(Info)));
